export default __webpack_public_path__ + "static/media/reims15.31676c59.jpg";